/* Dr. Zubala - enhancement layer: reveals, sticky header, mobile menu. */
(function(){
  'use strict';
  if(window.__dzEnh) return; window.__dzEnh = true;
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var root=document.documentElement;
    var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* scroll reveal */
    if('IntersectionObserver' in window && !reduce){
      root.classList.add('dz-motion');
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('dz-in'); io.unobserve(en.target); } });
      },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      document.querySelectorAll('.dz-section').forEach(function(el){ io.observe(el); });
    }
    /* sticky header state */
    var header=document.querySelector('.dz-header');
    if(header){
      var onScroll=function(){ header.classList.toggle('dz-scrolled', window.scrollY>8); };
      window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
      /* mobile menu toggle */
      var burger=header.querySelector('[data-dz-burger]');
      if(burger){
        burger.addEventListener('click',function(){
          var open=header.classList.toggle('dz-open');
          burger.setAttribute('aria-expanded',String(open));
        });
      }
    }
  });
})();
